import { useState } from 'react';
import { FaFacebook, FaWhatsapp, FaEnvelope } from 'react-icons/fa';
import { Modal, Input, Button, Space, Divider, message } from 'antd';
import { CopyOutlined, CloseOutlined } from '@ant-design/icons';

const ShareModalComponent = ({ isModalOpenShare, setIsModalOpenShare }) => {

    const shareUrl = window.location.href;
    const handleCancel = () => {
        setIsModalOpenShare(false);
    };
    const handleCopy = () => {
        navigator.clipboard.writeText(shareUrl);
        message.success('Link copied to clipboard!');
    };
    const handleGmailShare = () => {
        const subject = "Check out this exciting holiday for";
        const body = `Check this out: ${window.location.href}`;
        const mailtoLink = `https://mail.google.com/mail/?view=cm&fs=1&to=&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        window.open(mailtoLink, '_blank', 'noopener,noreferrer');
    }

    const shareOnFacebook = () => {
        window.open(
            `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
            '_blank',
            'noopener,noreferrer'
        );
    };

    const shareOnWhatsApp = () => {
        window.open(
            `https://wa.me/?text=${encodeURIComponent(`Check out this holiday package: ${shareUrl}`)}`,
            '_blank',
            'noopener,noreferrer'
        );
    };

    return (
        <>
            <Modal
                title="Share with friends"
                open={isModalOpenShare}
                onCancel={handleCancel}
                footer={null}
                closeIcon={<CloseOutlined />}
                centered
                width={600}
            >
                <div style={{ marginBottom: 16 }}>
                    <p style={{ color: '#666', marginBottom: 8 }}>Sharing link</p>
                    <Space.Compact style={{ width: '100%' }}>
                        <Input
                            value={shareUrl}
                            readOnly
                            style={{ backgroundColor: '#f5f5f5' }}
                        />
                        <Button
                            type="primary"
                            icon={<CopyOutlined />}
                            onClick={handleCopy}
                        >
                            Copy
                        </Button>
                    </Space.Compact>
                </div>

                <Divider plain>Or share on</Divider>

                <Space size="large" style={{ width: '100%', justifyContent: 'center' }}>
                    <Button
                        shape="circle"
                        icon={<FaFacebook style={{ color: '#3b5998', fontSize: 20 }} />}
                        size="large"
                        onClick={shareOnFacebook}
                        style={{ borderColor: '#d9d9d9' }}
                    />
                    <Button
                        shape="circle"
                        icon={<FaWhatsapp style={{ color: '#25D366', fontSize: 20 }} />}
                        size="large"
                        onClick={shareOnWhatsApp}
                        style={{ borderColor: '#d9d9d9' }}
                    />
                    <Button
                        shape="circle"
                        icon={<FaEnvelope style={{ color: '#666', fontSize: 20 }} />}
                        size="large"
                        onClick={handleGmailShare}
                        style={{ borderColor: '#d9d9d9' }}
                    />
                </Space>
            </Modal>
        </>
    );
};

export default ShareModalComponent;